import Vue from 'vue';

export function isInTab(element){
    if(element instanceof Vue){
        return isInTab(element.$el);
    }

    if(!element || element === Document.body){
        return false;
    }

    if(element.dataset?.isActivityTab){
        return true;
    }

    return isInTab(element.parentNode);
}

let tabInstances = new Map();
let id = 0;

export function registerTab(tabInstance){
    tabInstance.__tabId = id++;
    tabInstances.set(tabInstance.__tabId, tabInstance);
    tabInstances.$el.dataset.activityTabId = tabInstance.__tabId;
}

export function unregisterTab(tabInstance){
    tabInstances.delete(tabInstance.__tabId);
}

export function findTabById(id){
    if(tabInstances.has(id)){
        return tabInstances.get(id);
    }

    return null;
}